import { create } from "zustand";
import { MaintenanceForwardingData } from "../types/forwardings/maintenanceForwarding.type";
import { EquipmentData } from "@/common/types/cards/details.type";

interface UseWorkflowShowStore {
  init: () => void;

  forwarding: MaintenanceForwardingData | undefined;
  setForwarding: (forwarding: MaintenanceForwardingData | undefined) => void;

  equipment: EquipmentData | undefined;
  setEquipment: (equipment: EquipmentData | undefined) => void;

  currentEquipmentUsage: number | undefined;
  setCurrentEquipmentUsage: (currentEquipmentUsage: number | undefined) => void;
}

export const useWorkflowShowStore = create<UseWorkflowShowStore>((set) => ({
  init: () => set({
    forwarding: undefined,
  }),

  forwarding: undefined,
  setForwarding: (forwarding) => set({
    forwarding,
  }),

  equipment: undefined,
  setEquipment: (equipment) => set({
    equipment,
  }),

  currentEquipmentUsage: undefined,
  setCurrentEquipmentUsage: (currentEquipmentUsage) => set({
    currentEquipmentUsage,
  }),
}));
